export const programList = [
  { label: 'Official Depository', programKey: 'OD', subProgram: true },
  { label: 'Warrants & Appropriations', programKey: 'WAR', subProgram: true },
  { label: 'Payroll Register', programKey: 'PAYROLL', subProgram: true },
  { label: 'General Ledger', programKey: 'GL', subProgram: true },
  { label: 'Tax', programKey: 'TAX', subProgram: true },
  { label: 'Mortgage Company Bill Requests', programKey: 'MTGBILLREQUESTS', subProgram: false },
  { label: 'Mortgage Company Payments', programKey: 'MTGPAYMENTS', subProgram: false },
  { label: 'Mortgage Company Lockbox', programKey: 'MTGLOCKBOX', subProgram: false },
  { label: 'Apportionment', programKey: 'APPORT', subProgram: false },
];

export const programListImportAndMapper = [
  ...programList,
  { label: 'Miscellaneous Receipt', programKey: 'MISC' },
  { label: 'Mortgage Tax', programKey: 'MTG' },
  { label: 'Shared Program', programKey: 'SHARED' },
];

export const programListForExport = [
  ...programList,
  { label: 'Auditor Exports', programKey: 'AUDITOR' },
  { label: 'Miscellaneous Receipt', programKey: 'MISC', subProgram: true },
  { label: 'Mortgage Tax', programKey: 'MTG', subProgram: true },
];

export const programListForImport = [
  ...programListImportAndMapper,
];

export const programListForMappper = [
  ...programListImportAndMapper,
  ...programListForExport,
];

export const transformMapperFields = {
  _id: '',
  name: '',
  source: '',
  inputs: [],
  pipeline: [],
  fixedWidthTemplate: [],
  destination: '',
  reportTemplate: '',
  pdfReportTemplate: '',
  createDependency: false,
  backendToBackend: false,
  showJsonMapper: false,
  sourceTemplate: '', // for gql query
  program: '',
  model: '',
  subProgram: '',
  countySpecific: '',
  stringFieldNames: [],
  customConfig: {},
  batchSize: null,
};

export const transformMapperFieldsImport = {
  ...transformMapperFields,
};

export const transformMapperFieldsExport = {
  ...transformMapperFields,
  fileName: '',
  collectionName: '',
  jsonMapper: [],
};

export const transformMapperListFields = {
  ...transformMapperFields,
  type: '',
  fileName: '',
  collectionName: '',
  sourceTemplate: '',
  csvInputs: [],
  jsonMapper: [],
  previewData: '',
  folderName: '',
};

export const pipelineDefault = {
  _id: '',
  name: '',
  source: '',
  inputs: [],
  pipeline: [],
  fixedWidthTemplate: [],
  destination: '',
  reportTemplate: '',
  pdfReportTemplate: '',
};

export const pipelineDefaultImport = {
  ...pipelineDefault,
  createDependency: false,
  backendToBackend: false,
  showJsonMapper: false,
};

export const pipelineDefaultExport = {
  ...pipelineDefault,
};
